import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable no-param-reassign */
// p-queue does not have a `"main"` field in its `package.json`, and that makes `import/no-unresolved` freak out.
// We can safely ignore it because bundlers will happily use the `"exports"` field instead.
// eslint-disable-next-line import/no-unresolved
import PQueue from 'p-queue';
import shallowClone from './shallowClone.js';

var recursivelyFetch =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(queue, poorTree, poorFolder, apiList, validateSingleFile) {
    var items, currentPath, response, newFolders, newFiles, folders, files;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            items = [];
            currentPath = poorFolder.cached ? poorFolder.nextPagePath : poorFolder.id;

          case 2:
            if (!currentPath) {
              _context2.next = 10;
              break;
            }

            _context2.next = 5;
            return apiList(currentPath);

          case 5:
            response = _context2.sent;
            items = items.concat(response.items);
            currentPath = response.nextPagePath;
            _context2.next = 2;
            break;

          case 10:
            newFolders = items.filter(function (i) {
              return i.isFolder === true;
            });
            newFiles = items.filter(function (i) {
              return i.isFolder === false;
            });
            folders = newFolders.map(function (folder) {
              return {
                type: 'folder',
                id: folder.requestPath,
                cached: false,
                nextPagePath: null,
                status: 'checked',
                parentId: poorFolder.id,
                data: folder
              };
            });
            files = newFiles.map(function (file) {
              var restrictionError = validateSingleFile(file);
              return {
                type: 'file',
                id: file.requestPath,
                restrictionError: restrictionError,
                status: restrictionError ? 'unchecked' : 'checked',
                parentId: poorFolder.id,
                data: file
              };
            });
            poorFolder.cached = true;
            poorFolder.nextPagePath = null;
            poorTree.push.apply(poorTree, _toConsumableArray(files).concat(_toConsumableArray(folders)));
            folders.forEach(
            /*#__PURE__*/
            function () {
              var _ref2 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee(folder) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        queue.add(function () {
                          return recursivelyFetch(queue, poorTree, folder, apiList, validateSingleFile);
                        });

                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x6) {
                return _ref2.apply(this, arguments);
              };
            }());

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function recursivelyFetch(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var afterFill =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(partialTree, apiList, validateSingleFile, reportProgress) {
    var queue, poorTree, poorFolders;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            queue = new PQueue({
              concurrency: 6
            }); // fill up the missing parts of a partialTree!

            poorTree = shallowClone(partialTree);
            poorFolders = poorTree.filter(function (item) {
              return item.type === 'folder' && item.status === 'checked' && ( // either "not yet cached at all" or "some pages are left to fetch"
              item.cached === false || item.nextPagePath);
            }); // per each poor folder, recursively fetch all files and make them .checked!

            poorFolders.forEach(function (poorFolder) {
              queue.add(function () {
                return recursivelyFetch(queue, poorTree, poorFolder, apiList, validateSingleFile);
              });
            });
            queue.on('completed', function () {
              var nOfFilesChecked = poorTree.filter(function (i) {
                return i.type === 'file' && i.status === 'checked';
              }).length;
              reportProgress(nOfFilesChecked);
            });
            _context3.next = 7;
            return queue.onIdle();

          case 7:
            return _context3.abrupt("return", poorTree);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function afterFill(_x7, _x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

export default afterFill;